export default defineAppConfig({
  ui: {
    colors: {
      primary: "blue",
      neutral: "mist",
      success: "green",
      warning: "amber",
      error: "red",
      info: "sky",
    },
  },
});
